export enum CoverageType {
    Coverage = "COT_BASE_COVERAGE",
    CovOptions = "COT_ADDITIONAL_COVERAGE",
    Rider = "COT_RIDER",
    PrimaryInsured = "COT_PRIMARY_INSURED",
    ChiltrenTerm = "COT_CHILDREN_TERM",
    SpouseTerm = "COT_SPOUSE_TERM",
    OtherInsured = "COT_OTHER_INSURED",
    FamilyTerm = "COT_FAMILY_TERM",
    IndividualTerm = "COT_INDIVIDUAL_TERM",
    WaiverPremium = "COT_WAIVER_PREMIUM",
    WaiverMonthlyDeduction = "COT_WAIVER_MONTHLY_DEDUCTION",
    AccidentalDeathBenefit = "COT_ACCIDENTAL_DEATH_BENEFIT",
    AcceleratedDeathBenefit = "COT_ACCELERATED_DEATH_BENEFIT",
    CriticalIllness = "COT_CRITICAL_ILLNESS",
    DisabilityIncome = "COT_DISABILITY_INCOME",
    GuaranteedPurchase = "COT_GUARANTEED_PURCHASE",
    TermConversion = "COT_TERM_CONVERSION",
}

export enum LivesType {
    Single = "LIT_SINGLE",
    JointFirstToDie = "LIT_JOINT_LAST_TO_DIE",
    JointLastToDie = "LIT_JOINT_FIRST_TO_DIE",
}

export enum UnderwritingClass {
    PreferredPlus = "UNC_PREFERRED_PLUS",
    Preferred = "UNC_PREFERRED",
    Standard = "UNC_STANDARD",
}

export enum InsuredRole {
    Insured = "INR_INSURED",
    JointInsured = "INR_JOINT_INSURED",
}

export enum SmokerStatus {
    Smoker = "SMO_SMOKER",
    NonSmoker = "SMO_NON_SMOKER",
    Combined = "SMO_COMBINED",
    NonApplicable = "SMO_NON_APPLICABLE",
}

export enum BeneficiaryDesignation {
    Revocable = "BED_REVOCABLE",
    NonRevocable = "BED_NON_REVOCABLE",
}

export enum AgentRole {
    Agent = "AGR_AGENT",
    ServiceAgent = "AGR_SERVICE_AGENT",
}

export enum AgentAccountStatus {
    Active = "AAS_ACTIVE",
    Inactive = "AAS_INACTIVE",
    OnHold = "AAS_ON_HOLD",
}

export enum Gender {
    Male = "GEN_MALE",
    Female = "GEN_FEMALE",
}

export enum AddressPriority {
    Primary = "ADP_PRIMARY",
    Secondary = "ADP_SECONDARY",
}

export enum PhonePriority {
    Primary = "PHP_PRIMARY",
    Secondary = "PHP_SECONDARY",
}

export enum PhoneType {
    Home = "PHT_HOME",
    Mobile = "PHT_MOBILE",
    Office = "PHT_OFFICE",
    Fax = "PHT_FAX",
}

export enum ConvenientTime {
    Morning = "COT_MORNING",
    Afternoon = "COT_AFTERNOON",
    Night = "COT_NIGHT",
}

export enum PaymentType {
    EFT = "PAT_EFT",
    CreditCard = "PAT_CREDIT_CARD",
    DirectBill = "PAT_DIRECT_BILL",
    RolloverSuperFund = "PAT_ROLLOVER_SUPERFUND",
    RolloverSMSF = "PAT_ROLLOVER_SMSF",
    BillerCode = "PAT_BILLER_CODE",
    SuperStream = "PAT_SUPERSTREAM",
    Check = "PAT_CHECK",
    OtherPaymentType = "PAT_OTHER",
}

export enum PaymentFrequency {
    Yearly = "PAF_YEARLY",
    SemiAnnual = "PAF_SEMI_ANNUAL",
    Quarterly = "PAF_QUARTERLY",
    BiMonthly = "PAF_BIMONTHLY",
    Monthly = "PAF_MONTHLY",
    SemiMonthly = "PAF_SEMI_MONTHLY",
    BiWeekly = "PAF_BIWEEKLY",
    Weekly = "PAF_WEEKLY",
    Unique = "PAF_UNIQUE",
}

export enum BankAccountType {
    Checking = "BAT_CHECKINGS",
    Savings = "BAT_SAVINGS",
}

export enum PartyType {
    LegalSuccessors = "PAT_LEGAL_SUCCESSORS",
    Individual = "PAT_INDIVIDUAL",
    Company = "PAT_COMPANY",
}

export enum Title {
    Mr = "TIT_MR",
    Ms = "TIT_MS",
    Mrs = "TIT_MRS",
}

export enum CivilStatus {
    Married = "CIS_MARRIED",
    CommonInLaw = "CIS_COMMON_IN_LAW_PARTNER",
    Single = "CIS_SINGLE",
    Separated = "CIS_SEPARATED",
    Divorced = "CIS_DIVORCED",
    Widowed = "CIS_WIDOWED",
}

export enum Relationship {
    Shareholder = "REC_SHAREHOLDER",
    Associate = "REC_ASSOCIATE",
    Company = "REC_COMPANY",
    Creditor = "REC_CREDITOR",
    Employer = "REC_EMPLOYER",
    Trust = "REC_TRUST",
    Partner = "REC_PARTNER",
    Employee = "REC_EMPLOYEE",
    Married = "REC_MARRIED",
    CommonInLaw = "REC_COMMON_IN_LAW_PARTNER",
    Children = "REC_CHILDREN",
    Brother = "REC_BROTHER",
    Grandparent = "REC_GRANDPARENT",
    Parent = "REC_PARENT",
    Grandchildren = "REC_GRANDCHILDREN",
    Sister = "REC_SISTER",
    CommonLawHusband = "REI_COMMON_LAW_HUSBAND",
    CommonLawWife = "REI_COMMON_LAW_WIFE",
    DomesticPartner = "REI_DOMESTIC_PARTNER",
    Husband = "REI_HUSBAND",
    LifePartner = "REI_LIFE_PARTNER",
    SignificantOther = "REI_SIGNIFICANT_OTHER",
    Spouse = "REI_SPOUSE",
    Wife = "REI_WIFE",
    BrotherInLaw = "REI_BROTHER_IN_LAW",
    DaughterInLaw = "REI_DAUGHTER_IN_LAW",
    FatherInLaw = "REI_FATHER_IN_LAW",
    MotherInLaw = "REI_MOTHER_IN_LAW",
    SisterInLaw = "REI_SISTER_IN_LAW",
    SonInLaw = "REI_SON_IN_LAW",
    AdoptedChildren = "REI_ADOPTED_CHILDREN",
    AdoptedDaughter = "REI_ADOPTED_DAUGHTER",
    AdoptedSon = "REI_ADOPTED_SON",
    Daughter = "REI_DAUGHTER",
    Son = "REI_SON",
    StepChildren = "REI_STEP_CHILDREN",
    StepDaughter = "REI_STEP_DAUGHTER",
    StepSon = "REI_STEP_SON",
    StepBrother = "REI_STEP_BROTHER",
    HalfBrother = "REI_HALF_BROTHER",
    Grandfather = "REI_GRANDFATHER",
    Grandmother = "REI_GRANDMOTHER",
    Father = "REI_FATHER",
    Mother = "REI_MOTHER",
    StepFather = "REI_STEP_FATHER",
    StepMother = "REI_STEP_MOTHER",
    GrandDaughter = "REI_GRANDDAUGHTER",
    GrandSon = "REI_GRANDSON",
    StepSister = "REI_STEP_SISTER",
    HalfSister = "REI_HALF_SISTER",
    ExHusband = "REI_EX_HUSBAND",
    ExWife = "REI_EX_WIFE",
    Fiancee = "REI_FIANCEE",
    Friend = "REI_FRIEND",
    LegalGuardian = "REI_LEGAL_GUARDIAN",
    OtherFamily = "REI_OTHER_FAMILY",
    Unknown = "REI_UNKNOWN",
    Sibling = "REI_SIBLING",
    Aunt = "REI_AUNT",
    Cousin = "REI_COUSIN",
    Nephew = "REI_NEPHEW",
    Niece = "REI_NIECE",
    Uncle = "REI_UNCLE",
    NephewNice = "REI_NEPHEW_NIECE",
    UncleAunt = "REI_UNCLE_AUNT",
    GodFather = "REI_GOD_FATHER",
    GodMother = "REI_GOD_MOTHER",
    PowerAttorney = "REI_POWER_ATTORNEY",
    Other = "COM_OTHER",
}

export enum RatingType {
    TemporaryFlatExtra = "RTY_TEMPORARY_FLAT_EXTRA",
    PermanentFlatExtra = "RTY_PERMANENT_FLAT_EXTRA",
    TableRating = "RTY_MORTALITY_ASSESSMENT",
}

export enum RatingValueType {
    Amount = "RVT_AMOUNT",
    Percent = "RVT_PERCENTAGE",
}

// Use this in order to support values types 'currency' and 'percentage'
export class RatingValueTypeUtil {
    static isCurrency(type: RatingValueType | string) {
        return type === RatingValueType.Amount || type === "currency";
    }

    static isPercentage(type: RatingValueType | string) {
        return type === RatingValueType.Percent || type === "percentage";
    }
}

export enum ServiceType {
    Personal = "STY_PERSONAL",
    Company = "STY_COMPANY",
}

export enum RequirementName {
    PremiumDue = "REQ_PREMIUM_DUE",
    SocialSecurityNumber = "REQ_SOCIAL_SECURITY_NUMBER",
    InterviewRequested = "REQ_INTERVIEW_REQUESTED",
    UrineAnalysis = "REQ_URINE_ANALYSIS",
    RiskAnalysis = "REQ_RISK_ANALYSIS",
    RequiredDocument = "REQ_REQUIRED_DOCUMENT",
}

export enum RequirementStatus {
    Active = "RES_ACTIVE",
    Completed = "RES_COMPLETED",
}

export enum ActivityStatus {
    InProgress = "ACS_IN_PROGRESS",
    Finished = "ACS_FINISHED",
}

export enum ProductType {
    Life = "PRT_LIFE",
    Annuity = "PRT_ANNUITY",
    Motor = "PRT_MOTOR",
}

export enum ProductGroup {
    Annuity = "Annuity",
    Tarification = "Tarification",
}

export enum QualifiedStatus {
    NonQualified = "QS_NON_QUALIFIED",
    NonQualifiedInherited = "QS_NON_QUALIFIED_INHERITED",
    QualifiedOther = "QS_QUALIFIED_OTHER",
    QualifiedRothIra = "QS_QUALIFIED_ROTH_IRA",
    QualifiedSepIra = "QS_QUALIFIED_SEP_IRA",
    QualifiedTradictionalIra = "QS_QUALIFIED_TRADITIONAL_IRA",
}

export class CoverageConstants {
    public static MinimumRiskFaceAmount = 250000;
}

export enum OptionMenuType {
    Annuity = "Annuity",
    Policy = "Policy",
    CaseInAnalysis = "CaseInAnalysis",
}
